import { Tabs } from "antd";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  getCurrentRole,
  isProjectAdmin,
} from "../../../../../helpers/authFunctions";
import ProjectActivityTable from "../../../../activity-logs/ProjectActivityTable";
import { CM, FL, ML, PA, PFA, SM } from "../../../../router/AddRoutesJson";
import IndexOfClientProgressTab from "../../../client-manager/IndexOfClientProgressTab";
import GithubConnection from "../../../ml-role/GithubConnection";
import ProjectSpecificUploadedList from "../../../site-manger/list/ProjectSpecificUploadedList";
import ClientsForm from "../../clients/ClientsForm";
import ClientServerEc2InstanceTable from "../../infra/ClientServerEc2InstanceTable";
import IndexOfEc2Config from "../../infra/IndexOfEc2Config";
import useFLProjectCreationTab from "./../../../../../zustand/store/useFLProjectCreationTab";
import ProjectInfoForm from "./fl-form/ProjectInfoForm";
import ProjectSummary from "./fl-form/ProjectSummary";
import ModelTab from "./ModelTab";

const FLProjectsTab = () => {
  const { activeKey, setActiveKey } = useFLProjectCreationTab();

  const onChange = (key) => {
    setActiveKey(key);
  };

  const items = [
    {
      key: "TAB_PROJECT_INFO",
      label: "Project Info",
      children: <ProjectInfoForm />,
      role: [PA],
    },
    {
      key: "TAB_PROJECT_SUMMARY",
      label: "Project Summary",
      children: <ProjectSummary />,
      role: [PFA, FL, ML, SM, CM],
    },
    {
      key: "TAB_CLIENT",
      label: "Clients",
      children: <ClientsForm />,
      role: [PA, FL],
    },
    {
      key: "TAB_SITES",
      label: "Client Progress",
      children: <IndexOfClientProgressTab />,
      role: [PA, PFA, CM, FL],
    },
    {
      key: "MODEL_RUN",
      label: "Server Progress",
      children: <ModelTab />,
      role: [FL, PA],
    },
    // {
    //   key: "NEW_CLIENT_PROGRESS",
    //   label: "New Client",
    //   children: <IndexOfClientProgressTable />,
    //   role: [PA, PFA, CM, FL],
    // },
    // {
    //   key: "TAB_SITES_CM_FL",
    //   label: "Clients",
    //   children: <DataStatusTable />,
    //   role: [CM, FL],
    // },
    {
      key: "GITHUB_CONNECTIONS",
      label: "Configure Git",
      children: <GithubConnection />,
      role: [FL, PFA, PA],
    },
    {
      key: "TAB_INFRA_VIEW_ONLY",
      label: "Configure EC2 Instance",
      children: <ClientServerEc2InstanceTable />,
      role: [PA, PFA, CM],
    },
    {
      key: "TAB_INFRA_SIMPLE",
      label: "Configure EC2 Instance",
      children: <IndexOfEc2Config />,
      role: [FL],
    },
    {
      key: "TAB_UPLOAD",
      label: "Upload",
      children: <ProjectSpecificUploadedList />,
      role: [SM],
    },

    {
      key: "TAB_TIMELINE",
      label: "Project Log",
      children: <ProjectActivityTable />,
      role: [CM, ML, FL, PA, PFA],
    },
  ];
  const currentRole = getCurrentRole();

  const filteredItems = items.filter((item) =>
    item?.role?.includes(currentRole)
  );

  useEffect(() => {
    {
      isProjectAdmin()
        ? setActiveKey("TAB_PROJECT_INFO")
        : setActiveKey("TAB_PROJECT_SUMMARY");
    }
  }, []);
  const { id } = useParams();
  return (
    <>
      <Tabs
        destroyInactiveTabPane={id ? true : false}
        centered
        activeKey={activeKey}
        items={filteredItems}
        onChange={onChange}
      />
    </>
  );
};

export default FLProjectsTab;
